export default "__VITE_ASSET__60027139__"